// export const REACT_APP_BASE_API_URL: string =
//   "https://uno-backend-rkvd.onrender.com/api/v1/";
export const REACT_APP_BASE_API_URL:string ='https://uno-backend.vercel.app/api/v1'
export const REACT_APP_GOOGLE_CLIENT_ID: string =
  "517161187500-3btiskl906bkslmq6sfjp3f63t02ek8u.apps.googleusercontent.com";
